import { ChangeDetectionStrategy, Component, Inject, Input, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { VerifyExtras } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.models'

@Component({
  selector: 'gb-verify-dialog',
  templateUrl: './gb-verify-dialog.component.html',
  styleUrls: ['./gb-verify-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbVerifyDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data?: VerifyExtras) {}
}
